import styled from 'styled-components';
import palette from '../../../lib/styles/palette';
import { useRef, useState, useEffect, useCallback } from 'react';

import { MdExpandMore, MdExpandLess, MdRemoveCircleOutline, MdAdd } from 'react-icons/md';
// import ActionButtons from '../ActionButtons';
// import AskCancelModal from '../AskCancelModal';

// import { standardWeight_safetyCover } from '../../../lib/data/standard-weight';
// import { toFixedSafe } from '../../../lib/styles/perttierNumber';

const SafetyCover = ({ onSaveStructure, onChangeWeightSummary, safetyCovers }) => {
    const [isShow, setIsShow] = useState(safetyCovers?.length || false);
    const [newSafetyCover, setNewSafetyCover] = useState(safetyCovers || []);
    const [factor, setFactor] = useState('1.0');
    const [id, setId] = useState('');
    const [typeCategory1, setTypeCategory1] = useState('');
    const [typeCategory2, setTypeCategory2] = useState('');
    const [standardWeight, setStandardWeight] = useState('');
    const [qty, setQty] = useState('');
    const [unitWeight, setUnitWeight] = useState('');
    const [weight, setWeight] = useState('');
    const [totalQty, setTotalQty] = useState('');
    const [totalWeight, setTotalWeight] = useState('');
    // const [modal, setModal] = useState(false);
    /* 변경사항을 저장했었는지 여부에 대한 상태 저장 */
    const [isChanged, setIsChanged] = useState(false);

    /* Category 설명하는 text */
    const typeCategory1_Text = useRef({
        0: 'Safety Cover',
        1: 'Safety Fence',
    });

    const typeCategory2_Text = useRef({
        0: 'for Screw Type Takeup',
        1: 'for Vertical Gravity Type Takeup',
        2: 'for Horizontal Gravity Type Takeup',
    });

    /*  처음 props로 넘어온 safetyCovers를 초기값 그대로 보관하고 있다가 취소 버튼을 눌렀을 때 원상 복귀 시키기 위해
        useRef를 사용하여 저장해 둔다. */
    // const initialsafetyCover = useRef(safetyCovers || []);

    /* 타입별 Weight를 가져온다. */
    useEffect(() => {
        if (typeCategory1 === '0') {
            setStandardWeight(25); // 단순히 25kg/set
        } else {
            if (typeCategory2 === '0') {
                setStandardWeight(66);
            } else if (typeCategory2 === '1') {
                setStandardWeight(557);
            } else {
                setStandardWeight(1249);
            }
        }
    }, [typeCategory1, typeCategory2]);

    /* 단위 중량 계산 */
    useEffect(() => {
        // if (!standardWeight || !factor) {
        //     return;
        // }
        const _unitWeight = Math.ceil(standardWeight * factor);
        setUnitWeight(_unitWeight);
    }, [standardWeight, factor]);

    /* 중량 계산 */
    useEffect(() => {
        // if (!unitWeight || !qty) {
        //     return;
        // }
        const _weight = Math.ceil(unitWeight * qty);
        setWeight(_weight);
    }, [qty, unitWeight]);

    /* 마지막 ID 가져오기 함수 */
    const getLastId = useCallback(() => {
        if (!newSafetyCover.length) {
            return 0;
        }
        return Math.max(...newSafetyCover.map((item) => Number(item.id.substring(4))), 0);
    }, [newSafetyCover]);

    /* 입력 후 폼 초기화 함수 */
    const initializeForm = useCallback(() => {
        setId(`SFC-${getLastId() * 1 + 1}`);
        // setLength('');
        // setStandardWeight('');
        // setFactor('');
        // setTypeCategory1('');
        // setTypeCategory2('');
        // setStandardWeight('');
        setQty('');
        setUnitWeight('');
        setWeight('');
    }, [getLastId]);

    /* 전체 수량 계산 함수 */
    const getTotalQty = useCallback((items) => {
        const _totalQty = items.reduce((accumulator, currentValue) => {
            return accumulator + parseInt(currentValue.qty);
        }, 0);
        setTotalQty(_totalQty);
    }, []);

    /* 전체 중량 계산 함수 */
    const getTotalWeight = useCallback((items) => {
        const _totalWeight = items.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.weight;
        }, 0);
        setTotalWeight(_totalWeight);
    }, []);

    /* 추가 버튼을 누르면 newSafetyCover에 safetyCover 추가 */
    const onAddSafetyCover = useCallback(() => {
        if (!qty || !unitWeight || !weight) {
            alert('Check input(s) before saving!!!');
            return;
        }
        const safetyCover = {
            id,
            typeCategory1: typeCategory1_Text.current[typeCategory1],
            typeCategory2: typeCategory2_Text.current[typeCategory2],
            standardWeight,
            factor,
            qty,
            unitWeight,
            weight,
        };
        setNewSafetyCover((prev) => [...prev, safetyCover]);
        setIsChanged(true);
    }, [id, typeCategory1, typeCategory2, standardWeight, factor, qty, unitWeight, weight]);

    /* 삭제 버튼을 누르면 해당 safetyCover 삭제 */
    const onDeleteSafetyCover = useCallback((id) => {
        setNewSafetyCover((prev) => prev.filter((item) => item.id !== id));
        setIsChanged(true);
    }, []);

    /* newSafetyCover에 변화가 생기면 리덕스에 변경사항 쓰기 */
    useEffect(() => {
        getTotalQty(newSafetyCover);
        getTotalWeight(newSafetyCover);
        initializeForm();
        onSaveStructure({
            key: 'safetyCover',
            value: newSafetyCover,
        });
        onChangeWeightSummary({
            key: 'safetyCover',
            value: {
                totalQty,
                totalWeight,
            },
        });
    }, [
        getTotalQty,
        getTotalWeight,
        initializeForm,
        newSafetyCover,
        onChangeWeightSummary,
        onSaveStructure,
        totalQty,
        totalWeight,
    ]);

    /* Save 버튼을 누르면 리덕스에 변경사항 쓰기 */
    // const onSaveSafetyCover = useCallback(() => {
    //     onSaveStructure({
    //         key: 'safetyCover',
    //         value: newSafetyCover,
    //     });
    //     onChangeWeightSummary({
    //         key: 'safetyCover',
    //         value: {
    //             totalQty,
    //             totalWeight,
    //         },
    //     });
    // }, [newSafetyCover, onChangeWeightSummary, onSaveStructure, totalQty, totalWeight]);

    /* 변경 사항을 취소하면 newSafetyCover를 초기값으로 변경하고 리덕스에 초기값으로 쓰기 */
    // const onCancelChange = useCallback(() => {
    //     setNewSafetyCover(initialsafetyCover.current);
    //     onSaveStructure({
    //         key: 'safetyCover',
    //         value: initialsafetyCover.current,
    //     });
    //     onChangeWeightSummary({
    //         key: 'safetyCover',
    //         value: {},
    //     });
    //     setModal(false);
    // }, [onChangeWeightSummary, onSaveStructure]);

    /* Cancel Change 버튼을 눌렀을 때 */
    // const onClickCancel = useCallback(() => {
    //     // 저장된 적이 없다면 alert
    //     if (!isChanged) {
    //         alert('변경내용이 없습니다.');
    //         return;
    //     }
    //     setModal(true);
    // }, [isChanged]);

    return (
        <SafetyCoverBlock>
            <Title>
                <h3 style={{ width: '400px', margin: '0' }}>Safety Cover / Fence</h3>
                <div style={{ width: '120px' }}>Q'ty: {totalQty} ea</div>
                <div style={{ width: '170px' }}>Weight: {totalWeight} kg</div>
                <div style={{ fontSize: '1.25rem', fontWeight: 'bold', display: 'flex', alignItems: 'flex-end' }}>
                    {!isShow ? (
                        <MdExpandMore color="orange" onClick={() => setIsShow(true)} />
                    ) : (
                        <MdExpandLess color="orange" onClick={() => setIsShow(false)} />
                    )}
                </div>
            </Title>
            {isShow && (
                <>
                    <table>
                        <thead>
                            <tr>
                                <th>ID.</th>
                                <th>Type-I</th>
                                <th>Type-II</th>
                                <th>
                                    Standard W't
                                    <br />
                                    (kg/m3)
                                </th>
                                <th>Factor</th>
                                <th>
                                    단위중량
                                    <br />
                                    (kg/set)
                                </th>
                                <th>Q'ty</th>
                                <th>중량(kg)</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {newSafetyCover &&
                                newSafetyCover.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.id}</td>
                                        <td>{item.typeCategory1}</td>
                                        <td>{item.typeCategory2}</td>
                                        <td>{item.standardWeight}</td>
                                        <td>{item.factor}</td>
                                        <td>{item.unitWeight}</td>
                                        <td>{item.qty}</td>
                                        <td>{item.weight}</td>
                                        <td className="btn-delete" onClick={() => onDeleteSafetyCover(item.id)}>
                                            <MdRemoveCircleOutline />
                                        </td>
                                    </tr>
                                ))}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr className="input-form">
                                {/* <td><StyledInput readOnly value={id} onChange={(e) => setId(e.target.value)} /></td> */}
                                <td className="id-column">{id}</td>
                                <td className="td-radio">
                                    <div className="input-radio">
                                        <label>
                                            <input
                                                type="radio"
                                                name="typeCategory"
                                                value="0"
                                                onChange={(e) => setTypeCategory1(e.target.value)}
                                            />
                                            <span>Safety Cover</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="typeCategory"
                                                value="1"
                                                onChange={(e) => setTypeCategory1(e.target.value)}
                                            />
                                            <span>Safety Fence</span>
                                        </label>
                                    </div>
                                </td>
                                <td>
                                    {typeCategory1 === '0' ? (
                                        <> N/A </>
                                    ) : (
                                        <div>
                                            <select
                                                value={typeCategory2}
                                                onChange={(e) => setTypeCategory2(e.target.value)}
                                            >
                                                {/* <optgroup label="Take-up"> */}
                                                <option value="" selected disabled>
                                                    Takeup Type
                                                </option>
                                                <option value="0">Screw Type</option>
                                                <option value="1">Vertical Gravity Type</option>
                                                <option value="2">Horizontal Gravity Type</option>
                                                {/* </optgroup> */}
                                            </select>
                                        </div>
                                    )}
                                </td>
                                <td>{standardWeight}</td>
                                <td>
                                    <StyledInput
                                        // type="number"
                                        // min="0.1"
                                        // max="3"
                                        // step="0.1"
                                        placeholder="..."
                                        value={factor}
                                        onChange={(e) => setFactor(e.target.value)}
                                    />
                                </td>
                                <td>{unitWeight}</td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={qty}
                                        onChange={(e) => setQty(e.target.value)}
                                    />
                                </td>
                                <td className="total-weight">{weight}</td>
                                <td className="btn-add" onClick={onAddSafetyCover}>
                                    <MdAdd />
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={5}>Safety Cover Total</td>
                                <td></td>
                                <td>{totalQty}</td>
                                <td>{totalWeight}</td>
                            </tr>
                        </tfoot>
                    </table>
                    {/* <ActionButtons confirmText="Save" cancelText="Cancel Change" onConfirm={onSaveSafetyCover} onCancel={onClickCancel} /> */}
                    {/* <AskCancelModal visible={modal} onConfirm={onCancelChange} onCancel={() => setModal(false)} /> */}
                </>
            )}
        </SafetyCoverBlock>
    );
};

/* =================   Styles   ================== */
const Title = styled.div`
    display: flex;
    align-items: flex-end;
    margin-bottom: 1rem;

    color: ${palette.cyan[6]};
`;

const SafetyCoverBlock = styled.div`
    // max-width: 1280px;
    // margin: 0 auto;
    // margin: 0 2rem;
    .btn-delete {
        color: ${palette.cyan[6]};
        font-size: 1rem;
        cursor: pointer;
        padding: 0 1rem;
        padding-top: 0.3rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    .btn-add {
        color: ${palette.cyan[6]};
        font-size: 1.5rem;
        cursor: pointer;
        padding: 0;
        padding-top: 0.4rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    table {
        width: 100%;
        font-size: 0.9rem;
        border-collapse: collapse;
    }
    thead {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        color: ${palette.gray[7]};
    }
    tfoot {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        height: 2.5rem;
        font-weight: bold;
        color: ${palette.gray[7]};
    }
    th {
        padding: 0.5rem 0.25rem;
        text-align: center;
    }
    td {
        padding: 0.25rem 0.25rem;
        text-align: center;
    }
    .td-radio {
        display: flex;
        justify-content: center;
        margin: 0 auto;
    }
    .input-radio {
        display: flex;
        flex-direction: column;
        // margin: 0 auto;
        align-items: flex-start;
        span {
            margin-left: 0.5rem;
        }
        // 추가함
        label + label {
            margin-top: 0.5rem;
        }
    }
    h3 {
        color: ${palette.cyan[6]};
    }
    .input-form {
        background-color: ${palette.gray[0]};
    }
`;

const StyledInput = styled.input`
    border: none;
    outline: none;
    padding: 0.25rem 0.5rem;
    width: 50px;
    text-align: center;
    background: transparent;
    &:hover {
        background: ${palette.gray[3]};
    }
`;

export default SafetyCover;
